import { Injectable } from '@angular/core';
import { of, Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class StorageService {
  adminSigninUser = false;
  constructor() {}

  /**
   * Save items to local storage
   * By key, value pairs
   * @param {string} key the name of property
   * @param {string} value the value we need to store
   * @returns {Observable<void>}
   * @memberof StorageService
   */
  setItem(key: string, value: string): Observable<void> {
    return of(localStorage.setItem(key, value));
  }

  /**
   * Get the value from local storage for a given property
   * @param {string} key the key of the item we need
   * @returns {Observable<string>} the value of the given key
   * @memberof StorageService
   */
  getItem(key: string): Observable<string> {
    return of(localStorage.getItem(key));
  }

  /**
   * Get the token for the current active user
   * @returns {string} User Token
   * @memberof StorageService
   */
  getToken(): string {
    return localStorage.getItem('token');
  }

  /**
   * Clear the localstorge and active variables
   * @returns {Observable<void>}
   * @memberof StorageService
   */
  clearStorage(): Observable<void> {
    location.reload();
    return of(localStorage.clear());
  }

  /**
   * Get the current language for the user
   * @returns {string} Current Language
   * @memberof StorageService
   */
  getLang(): string {
    return localStorage.getItem('lang') ? localStorage.getItem('lang') : 'en';
  }
}
